export default "__VITE_ASSET__DQOth3da__"